export default "__VITE_ASSET__DGydiNH___"